module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }